// src/actions/registration-url.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const GET_REGISTRATION_URL = "GET_REGISTRATION_URL"
export const GET_REGISTRATION_URL_REQUESTED = "GET_REGISTRATION_URL_REQUESTED"
export const GET_REGISTRATION_URL_COMPLETED = "GET_REGISTRATION_URL_COMPLETED"
export const GET_REGISTRATION_URL_FAILED = "GET_REGISTRATION_URL_FAILED"

export function getRegistrationUrlRequested() {
  return {
    type: GET_REGISTRATION_URL_REQUESTED
  }
}

export function getRegistrationUrl(group_id) {
  return function(dispatch) {
    dispatch(getRegistrationUrlRequested())
    return api.get(`/registration_url`, {group_id})
        .then((results)=> {
          dispatch(getRegistrationUrlCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(getRegistrationUrlFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function getRegistrationUrlCompleted(results) {
  return {
    type: GET_REGISTRATION_URL_COMPLETED,
    results,
  }
}

export function getRegistrationUrlFailed(error) {
  return {
    type: GET_REGISTRATION_URL_FAILED,
    error,
  }
}


// WEBPACK FOOTER //
// ./src/actions/registration-url.js